import React from 'react';
import Icon from '../../common/Icons';
import {
  COVERAGE_FILTER_OPTIONS,
  PRICING_FILTER_OPTIONS
} from './actPricingUtils';

export default function PricingToolbar({
  search,
  onSearchChange,
  searchPlaceholder,
  pricingFilter,
  onPricingFilterChange,
  coverageFilter,
  onCoverageFilterChange,
  showCoverageFilter = false,
  resultCount = 0,
  refreshing = false,
  hasActiveFilters = false,
  onClearFilters,
  clearFiltersLabel = 'Réinitialiser les filtres'
}) {
  return (
    <div className="ap-pricing-toolbar">
      <div className="ap-pricing-toolbar__row ap-pricing-toolbar__row--primary">
        <label className="ap-pricing-search">
          <Icon name="search" size={16} className="ap-pricing-search__icon" aria-hidden />
          <input
            className="ap-pricing-search__input"
            type="search"
            value={search}
            onChange={(e) => onSearchChange(e.target.value)}
            placeholder={searchPlaceholder}
            aria-label="Rechercher un acte"
            autoComplete="off"
          />
        </label>

        <div className="ap-pricing-toolbar__meta" aria-live="polite">
          {refreshing ? (
            <span className="ap-pricing-toolbar__count ap-pricing-toolbar__count--busy">
              <span className="ap-pricing-toolbar__spin" aria-hidden />
              Actualisation…
            </span>
          ) : (
            <span className="ap-pricing-toolbar__count">
              {resultCount.toLocaleString('fr-FR')} acte{resultCount !== 1 ? 's' : ''}
            </span>
          )}
          {hasActiveFilters && onClearFilters ? (
            <button type="button" className="ap-pricing-clear-btn ap-pricing-clear-btn--sm" onClick={onClearFilters}>
              {clearFiltersLabel}
            </button>
          ) : null}
        </div>
      </div>

      <div className="ap-pricing-toolbar__row ap-pricing-toolbar__row--filters">
        <div className="ap-pricing-filter-group" role="group" aria-label="Filtrer par tarification">
          <span className="ap-pricing-filter-group__label">
            <Icon name="filter" size={14} aria-hidden />
            Tarification
          </span>
          <div className="ap-pricing-chips">
            {PRICING_FILTER_OPTIONS.map((opt) => (
              <button
                key={opt.id}
                type="button"
                aria-pressed={pricingFilter === opt.id}
                className={`ap-pricing-chip-btn ${pricingFilter === opt.id ? 'is-active' : ''}`}
                onClick={() => onPricingFilterChange(opt.id)}
              >
                {opt.label}
              </button>
            ))}
          </div>
        </div>

        {showCoverageFilter ? (
          <div className="ap-pricing-filter-group" role="group" aria-label="Filtrer par prise en charge">
            <span className="ap-pricing-filter-group__label">Prise en charge</span>
            <div className="ap-pricing-chips">
              {COVERAGE_FILTER_OPTIONS.map((opt) => (
                <button
                  key={opt.id || 'all'}
                  type="button"
                  aria-pressed={coverageFilter === opt.id}
                  className={`ap-pricing-chip-btn ${coverageFilter === opt.id ? 'is-active' : ''}`}
                  onClick={() => onCoverageFilterChange(opt.id)}
                >
                  {opt.label}
                </button>
              ))}
            </div>
          </div>
        ) : null}
      </div>
    </div>
  );
}
